import React from 'react';
import { Pagination, Form } from 'react-bootstrap';

interface PaginationComponentProps {
    page: number;
    size: number;
    total: number;
    totalPages: number;
    pageSizeOptions?: number[];
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    entityLabel?: string; // e.g. "entidades", "usuários"
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
    page,
    size,
    total,
    totalPages,
    pageSizeOptions = [2, 5, 10, 50],
    onPageChange,
    onPageSizeChange,
    entityLabel = 'itens'
}) => {
    if (totalPages <= 0) return null;

    return (
        <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-center gap-2">
                <span>Itens por página:</span>
                <Form.Control
                    as="select"
                    value={size}
                    onChange={e => onPageSizeChange(Number(e.target.value))}
                    style={{ width: 'auto' }}
                >
                    {pageSizeOptions.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                    ))}
                </Form.Control>
            </div>
            <div className="d-flex align-items-center gap-3">
                <span>
                    Mostrando {page * size + 1} a{' '}
                    {Math.min((page + 1) * size, total)} de {total} {entityLabel}
                </span>
                <Pagination className="mb-0">
                    <Pagination.Item
                        disabled={page === 0}
                        onClick={() => onPageChange(0)}
                        title="Primeira página"
                    >
                        <span aria-hidden="true">&laquo;</span>
                    </Pagination.Item>
                    <Pagination.Item
                        disabled={page === 0}
                        onClick={() => onPageChange(page - 1)}
                        title="Página anterior"
                    >
                        <span aria-hidden="true">&lsaquo;</span>
                    </Pagination.Item>
                    {/* Only current page number */}
                    <span
                        className="page-link bg-primary text-white"
                        style={{
                            borderRadius: '0.25rem',
                            margin: '0 2px',
                            padding: '0.375rem 0.75rem',
                            border: '1px solid #dee2e6'
                        }}
                    >
                        {page + 1}
                    </span>
                    <Pagination.Item
                        disabled={page === totalPages - 1}
                        onClick={() => onPageChange(page + 1)}
                        title="Próxima página"
                    >
                        <span aria-hidden="true">&rsaquo;</span>
                    </Pagination.Item>
                    <Pagination.Item
                        disabled={page === totalPages - 1}
                        onClick={() => onPageChange(totalPages - 1)}
                        title="Última página"
                    >
                        <span aria-hidden="true">&raquo;</span>
                    </Pagination.Item>
                </Pagination>
            </div>
        </div>
    );
};

export default PaginationComponent; 